import { render } from "./QRCode.vue?vue&type=template&id=0fdde853&scoped=true"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=0fdde853&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Vue\\NK\\Register_studen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdde853"]])

export default __exports__